import { HEADER_HEIGHT } from "@/config/constants";
import { logout } from "@/utils/firebase";
import { withTaskListFilters } from "@/utils/taskListFilters";
import { useTaskListFilters } from "@/hooks/useTaskListFilters";
import { IconLogout } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { createContext, type ReactNode, useContext } from "react";
import { createPortal } from "react-dom";

/** The header's area for page-specific content. */
export const HeaderSlotContext = createContext<HTMLElement | null>(null);

/**
 * Renders its children in the header, between the title and the logout button. The content
 * leaves the header when the page that renders it unmounts.
 */
export const HeaderContent = ({ children }: { children: ReactNode }) => {
  const slot = useContext(HeaderSlotContext);
  return slot ? createPortal(children, slot) : null;
};

type HeaderProps = {
  slotRef: (element: HTMLDivElement | null) => void;
};

export const Header = ({ slotRef }: HeaderProps) => {
  // Back to the task list, keeping the filters selected there.
  const [taskListFilters] = useTaskListFilters();

  return (
    <header
      className="bg-white shadow-sm border-b border-gray-200 fixed top-0 left-0 right-0 z-10"
      style={{ height: HEADER_HEIGHT }}
    >
      <div className="px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <h1 className="shrink-0 text-xl font-semibold text-gray-900">
              <Link to={withTaskListFilters("/", taskListFilters)}>
                Track Labeling
              </Link>
            </h1>
          </div>
          <div
            ref={slotRef}
            className="flex min-w-0 flex-1 items-center gap-4"
          />
          <div className="flex items-center space-x-4">
            <button
              className="text-gray-500 hover:text-gray-700"
              onClick={logout}
            >
              <IconLogout />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
